import SignupPage from '../components/Signup/SignupPage';

function SignupPageWrapper() {
  return <SignupPage />;
}

export default SignupPageWrapper;
